import { useCallback, useState } from 'react'

export const useEditedFormData = (): {
  someSomeDataIsEdited: boolean
  editFormData: EditFormData
  editedFormData: EditedFormData
  refreshEditedFormData: () => void
} => {
  const [someSomeDataIsEdited, setSomeSomeDataIsEdited] = useState(false)
  const [editedFormData, setEditedFormData] = useState({})
  const editFormData = useCallback((field: string) => {
    setEditedFormData(prev => {
      return {
        ...prev,
        [field]: true,
      }
    })
    setSomeSomeDataIsEdited(true)
  }, [])
  const refreshEditedFormData = useCallback(() => {
    setEditedFormData({})
    setSomeSomeDataIsEdited(false)
  }, [])

  return {
    someSomeDataIsEdited,
    editedFormData,
    editFormData,
    refreshEditedFormData,
  }
}

// Public types.
export type EditFormData = (field: string) => void
export type EditedFormData = {
  [field: string]: boolean
}
